import React, { useEffect, useState } from "react";
import Popup from "../../../components/common/model/Popup";
import checkedIcon from "../../../assets/check-mark.png";
import closeIcon from "../../../assets/closeModel.png";
import useStyles from "../../../components/common/model/styles";
import { DialogContent, DialogContentText, Grid } from "@mui/material";

import CustomButton from "../../../components/common/button/CustomButton";
import Validation from "../../../utils/Validation";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {
  addNewLeadAction,
  resetNewLeadLocal,
  setNewLeadLocal,
  setUpdateLeadAction,
  updateLeadAction,
} from "../../../store/reducers/leadSlice";
import { setNotificationAction } from "../../../store/reducers/mmymSlice";
import Notification from "../../../components/common/notification/Notification";
import FormField from "../../../components/common/FormField";
import { leadReleventFields } from "./leadAllFields";
import dayjs from "dayjs";
import { mergeDateAndTime } from "../../../hooks/helper";

interface ManageReleventProps {
  open: boolean; // Define the 'open' prop
  onHide: () => void; // Define the 'onHide' prop
  title: string; // Define the 'title' prop
  selectLead: any; // Adjust type as per your requirement
  action?: any;
}

const ManageRelevent: React.FC<ManageReleventProps> = (props) => {
  const classes = useStyles();


  const { onHide, open, title, selectLead } = props;

  const [isActionCalled, setIsActionCalled] = useState(false);
  const [countryCode, setCountryCode] = useState<string>("+44"); // State for country code
  const dispatch = useDispatch();
  const { newLeadLocal, isAddLeadSuccess } = useSelector(
    (state: any) => state.lead,
  );

  useEffect(() => {
    if (selectLead) {
      const extractedCountryCode =
        selectLead.customer_phone?.match(/^\+91|\+44/);
      setCountryCode(extractedCountryCode ? extractedCountryCode[0] : "+44");

      // Safely convert address fields from string to number
      const collectionAddress = (
        selectLead?.collection_address?.length > 0
          ? selectLead?.collection_address
          : [
              {
                building_number: "",
                street: "",
                town: "",
                county: "",
                postcode: "",
                country: "",
                purchaseStatus: "",
                houseSize: "",
                distance: 0,
                volume: 0,
                volumeUnit: "m3",
              },
            ]
      ).map((addr: any) => ({
        ...addr,
        county: addr?.county,
        country: addr?.country,
        distance: addr?.distance ? Number(addr.distance) : 0,
        volume: addr?.volume ? Number(addr.volume) : 0,
        volumeUnit: addr?.volume_unit || "m3",
        houseSize: addr?.house_size,
        purchaseStatus: addr?.purchase_status,
      }));

      const deliveryAddress = (
        selectLead?.delivery_address?.length > 0
          ? selectLead?.delivery_address
          : [
              {
                building_number: "",
                street: "",
                town: "",
                county: "",
                postcode: "",
                country: "",
                purchaseStatus: "",
                houseSize: "",
                distance: 0,
                volume: 0,
                volumeUnit: "m3",
              },
            ]
      ).map((addr: any) => ({
        ...addr,
        county: addr?.county,
        country: addr?.country,
        distance: addr?.distance ? Number(addr.distance) : 0,
        volume: addr?.volume ? Number(addr.volume) : 0,
        volumeUnit: addr?.volume_unit || "m3",
        houseSize: addr?.house_size,
        purchaseStatus: addr?.purchase_status,
      }));

      const updatedLead = {
        ...newLeadLocal,
        referrerId: selectLead?.referrer_id ?? "",
        clientReferrerId: selectLead?.client_referrer_id ?? "",
        customer: {
          name: selectLead?.customer_name,
          phone: selectLead?.customer_phone
            ? selectLead?.customer_phone.replace(/^(\+91|\+44)/, "")
            : "",
          email: selectLead?.customer_email,
        },
        collectionAddress,
        deliveryAddress,
        // followUpDate: selectLead?.follow_up_date,
        // Date-only value for the date picker
        followUpDate: selectLead?.follow_up_date
          ? dayjs(selectLead.follow_up_date).format("YYYY-MM-DD")
          : "",

        // {start, end} object for the timerange picker
        followUpEndDate:
          selectLead?.follow_up_date && selectLead?.follow_up_end_date
            ? {
                start: selectLead.follow_up_date,
                end: selectLead.follow_up_end_date,
              }
            : "",
        movingOnDate: selectLead?.moving_on_end_date
          ? [selectLead?.moving_on_date, selectLead?.moving_on_end_date].filter(
              Boolean,
            )
          : selectLead?.moving_on_date,
        movingOnEndDate: selectLead?.moving_on_end_date,
        packingOnDate: selectLead?.packing_on_date,
        moveType: selectLead?.type_of_move,
        returningDistance: Number(selectLead?.returning_distance),
        advert_id: selectLead?.advert_id,
        promo_code: selectLead?.promo_code,
        promo_source: selectLead?.promo_source,
        sales_person_id: selectLead?.sales_person_id,
        sales_person_name: selectLead?.sales_person_name,
        lead_type_id: selectLead?.lead_type_id,
        customerNotes: selectLead?.customer_notes,
      };
      dispatch(setNewLeadLocal(updatedLead));
    }
  }, [selectLead]);

  const [
    error,
    checkValidator,
    resetValidator,
    resetAllValidator,
    isError,
    isErrorOptional,
  ]: any = Validation({
    name: newLeadLocal?.customer?.name,
    email: newLeadLocal?.customer?.email,
    // phone: newLeadLocal?.customer?.phone,
    // movingOnDate: newLeadLocal?.movingOnDate,
    // followUpDate: newLeadLocal?.followUpDate,
    // packingOnDate: newLeadLocal?.packingOnDate,
  });

  const hideHandler = () => {
    props.onHide();
    dispatch(resetNewLeadLocal());
    dispatch(setUpdateLeadAction(false));
    dispatch(setNewLeadLocal(false));
    dispatch(setNotificationAction({ message: [], severity: "error" }));
    resetAllValidator();
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    checkValidator();
    setIsActionCalled(true);
  };


  useEffect(() => {
    if (isActionCalled) {
      const { start, end } = newLeadLocal?.followUpEndDate || {};

      const followUpDate = mergeDateAndTime(newLeadLocal?.followUpDate, start) || newLeadLocal?.followUpDate || ""; // Use the original date if merging fails
      const followUpEndDate = mergeDateAndTime(newLeadLocal?.followUpDate, end);

      const processedLeadValue = {
        ...newLeadLocal,
        followUpDate,
        followUpEndDate,
        // Convert strings to numbers for each address object in collectionAddress
        collectionAddress: (newLeadLocal?.collectionAddress || []).map(
          (item: any) => ({
            ...item,
            distance: Number(item?.distance) || 0,
            volume: Number(item?.volume) || 0,
          }),
        ),

        // Convert strings to numbers for each address object in deliveryAddress
        deliveryAddress: (newLeadLocal?.deliveryAddress || []).map(
          (item: any) => ({
            ...item,
            distance: Number(item?.distance) || 0,
            volume: Number(item?.volume) || 0,
          }),
        ),
        customer: {
          ...newLeadLocal?.customer,
          phone: newLeadLocal?.customer?.phone
            ? `${countryCode}${newLeadLocal?.customer?.phone}`
            : "",
        },
        movingOnDate: Array.isArray(newLeadLocal?.movingOnDate)
          ? newLeadLocal?.movingOnDate[0]
          : newLeadLocal?.movingOnDate,
        movingOnEndDate: Array.isArray(newLeadLocal?.movingOnDate)
          ? newLeadLocal?.movingOnDate[1]
          : newLeadLocal?.movingOnEndDate,
      };

      if (
        !isError() &&
        !isErrorOptional() &&
        error !== null &&
        isActionCalled
      ) {
        if (selectLead?.generated_id) {
          dispatch(
            updateLeadAction({
              ...processedLeadValue,
              id: selectLead?.generated_id,
            }),
          );
        } else {
          dispatch(addNewLeadAction(processedLeadValue));
        }
      }
      setIsActionCalled(false);
    }
  }, [isActionCalled]);
  const closeModel = () => {
    hideHandler();
  };

  useEffect(() => {
    if (isAddLeadSuccess) {
      hideHandler();
    }
  }, [isAddLeadSuccess]);

  const onChangeAction = (event: any) => {
    const { id, value } = event.target;
    let updatedLeadLocal = { ...newLeadLocal, [id]: value };

    if (id === "movingOnDate") {
      if (Array.isArray(value)) {
        updatedLeadLocal.movingOnEndDate = value[1]; // Second date
      } else {
        updatedLeadLocal.movingOnDate = value;
        updatedLeadLocal.movingOnEndDate = ""; // Reset the end date if not an array
      }
      const movingOnDate = dayjs(value);
      const packingOnDate = newLeadLocal?.packingOnDate
        ? dayjs(newLeadLocal?.packingOnDate)
        : null;

      // Check if packingOnDate is valid and if movingOnDate is before packingOnDate
      if (
        packingOnDate &&
        movingOnDate.isValid() &&
        movingOnDate.isBefore(packingOnDate)
      ) {
        updatedLeadLocal.packingOnDate = ""; // Reset the packingOnDate
        updatedLeadLocal.followUpDate = ""; // Reset the followUpDate
      }
    }

    dispatch(setNewLeadLocal(updatedLeadLocal));

    resetValidator(event.target.id);
  };

  const onBlurAction = (e: any) => {
    checkValidator(e.target.id);
  };

  return (
    <>
      <Popup
        open={open} // Example value, replace with your actual state or variable
        title={title} // Example title, replace with your actual title
        onHide={hideHandler}
        fullWidth
        maxWidth={"sm"}
        aria-describedby="alert-dialog-slide-description"
        popupBg="#fff"
        header={
          <>
            <img
              onClick={(e: any) => handleSubmit(e)}
              src={checkedIcon}
              className={classes.checkicons}
              style={{ right: 40 }}
              alt="save"
            />
            <img
              onClick={hideHandler}
              src={closeIcon}
              className={classes.closeicons}
              alt="close"
            />
          </>
        }
        footer={
          <>
            {/* <CustomButton
              style={{ padding: "10px 30px", height: "36px" }}
              title="Save"
              onClick={handleSubmit}
            />
            <CustomButton
              style={{ padding: "10px 30px", height: "36px" }}
              variant="outlined"
              title="Cancel"
              onClick={closeModel}
            /> */}
          </>
        }
      >
        <DialogContent sx={{ padding: "10px" }}>
          <DialogContentText>
            <>
              <Notification />
              <Grid
                container
                spacing={2}
                sx={{
                  marginTop: "10px",
                  background: "#E5F4F1",
                  border: "1px solid #CFCFCF",
                  padding: "0px 10px 16px 0px",
                  borderRadius: "5px",
                }}
              >
                {leadReleventFields?.map((field, i) => {
                  return (
                    <FormField
                      key={field.id}
                      onPaste={(e: any) => e.preventDefault()}
                      {...{
                        ...field,
                        // multiline: true,
                        value: newLeadLocal ? newLeadLocal[field?.id] : "",
                        minDate:
                          field.id === "movingOnDate" ||
                          field.id === "packingOnDate"
                            ? new Date()
                            : undefined,
                        maxDate:
                          field.id === "packingOnDate"
                            ? newLeadLocal?.movingOnEndDate
                              ? dayjs(newLeadLocal?.movingOnDate[0]).toDate()
                              : dayjs(newLeadLocal?.movingOnDate).toDate()
                            : // : field.id === "followUpDate"
                              //   ? newLeadLocal?.packingOnDate
                              //     ? dayjs(newLeadLocal?.packingOnDate).toDate()
                              //     : dayjs(newLeadLocal?.movingOnDate).toDate()
                              undefined,
                        ...{
                          variant: "outlined", // Adding this variant prop
                          inSingleGridForm: true,
                          onChange: onChangeAction,
                          onBlur: onBlurAction,
                          isNonMarginTop: true,
                          InputProps: {
                            sx:
                              field?.type === "text" ||
                              field?.type === "password"
                                ? { height: "auto" }
                                : { padding: "10px 4px", height: "36px" },
                          },
                        },
                        error: error && error[field?.id],
                        //     emailSettingError && emailSettingError[field?.id],
                        // helperText:
                        // error && error[field?.id],
                      }}
                    />
                  );
                })}
              </Grid>
            </>
          </DialogContentText>
        </DialogContent>
      </Popup>
    </>
  );
};
export default ManageRelevent;
